module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_vm._v("Plugins")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3a961de0"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/HeaderNav.vue
// module id = 343
// module chunks = 1